import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import {
    REFERAL_DATA
} from '@/forms/constants/services';

const resource = '/onboarding/application/referral/v1.1';

export default {
    referralData(payload) {
        return Repository.post(`${resource}`, payload, {
            params: getParams(REFERAL_DATA
            ),
        });
    },
};